import React, { useState } from "react";
import assets from "../../../../../../assets/assets";
import { Check } from "lucide-react";
import {
  IconController,
  ImgController,
} from "../../../../../Scripts/ImgController";
import { useContract } from "../../../../../../provider/ContractProvider";
import ActionButtons from "../ActionButtons";
import Modal from "../Modal";
import {
  GLOBAL_SECTION,
  REGULAR_SECTION,
  SPECIAL_SECTION,
} from "../../../../../static";
import NotificationPopup from "../../../../Login/NotificationPopup";

// Contract types
const NORMAL_CONTRACT = "regular";
const SPECIAL_CONTRACT = "special";
const INTERNATIONAL_CONTRACT = "global";

const contracts = [
  {
    title: "Энгийн буюу 60:40 орлого хуваалт",
    percentage: "60%",
    description:
      "Энэ нь та өөрийн нийлүүлж буй дуунуудын дараах эрхийг онцгой бус буюу энгийн хувилбараар ММюзик Дистрибюшнд нийлүүлж буйг илтгэнэ. Иймд та тус эрхийг Монгол Улсад үйл ажиллагаа явуулж буй ижил төстэй байгууллагуудад борлуулах боломжтой.",
    badge: "MKaraoke",
    badgePercent: "50%",
    agreement_type: NORMAL_CONTRACT,
  },
  {
    title: "Онцгой буюу 70:30 орлого хуваалт",
    percentage: "70%",
    description:
      "Энэ нь та өөрийн нийлүүлж буй дуунуудын дараах эрхийг онцгой хувилбараар ММюзик Дистрибюшнд нийлүүлж буйг илтгэнэ. Иймд та тус эрхийг ММюзик Дистрибюшнтэй ижил төстэй Монгол Улсад үйл ажиллагаа явуулж буй компаниудад борлуулах боломжгүй.",
    badge: "MKaraoke",
    badgePercent: "50%",
    agreement_type: SPECIAL_CONTRACT,
  },
  {
    title: "Онцгой буюу 70:30 орлого хуваалт мөн ОУ-ын түгээлт",
    percentage: "70%",
    description:
      "Энэ нь та бидэнд өөрийн нийлүүлж буй дуунуудын дараах эрхийг онцгой хувилбараар нийлүүлж буйг илтгэх бөгөөд, тус эрхүүдийг бусад ММюзик Дистрибюшнтэй ижил төстэй Монгол Улсад үйл ажиллагаа явуулж буй компаниудад борлуулах боломжгүй. Мөн энэ план нь ММюзик Дистрибюшнд нь таны дууг ОУ-ын Facebook, Instagram, Spotify, Apple Music, YouTube гэх мэт платформууд дээр байршуулах эрхийг нэмэлтээр өгч буй юм.",
    badge: "MKaraoke",
    badgePercent: "50%",
    global_badge: "GLobal",
    global_icon: "MetaIcon",
    agreement_type: INTERNATIONAL_CONTRACT,
  },
];

const getContractSection = (type) => {
  switch (type) {
    case NORMAL_CONTRACT:
      return REGULAR_SECTION;
    case SPECIAL_CONTRACT:
      return SPECIAL_SECTION;
    case INTERNATIONAL_CONTRACT:
      return GLOBAL_SECTION;
    default:
      return null;
  }
};

const ContractBadge = ({ contract }) => {
  const isGlobal = !!contract.global_badge;
  return (
    <div
      className={`rounded-[20px] p-4 flex items-end flex-col space-y-3 min-h-[86px] w-[145px] ${
        isGlobal ? "custom-gradient_3" : "custom-gradient"
      }`}
    >
      <div className="flex flex-col items-center space-y-0.5">
        <span className="badge-gradient text-xs text-white font-bold px-3 py-1 rounded-full">
          {contract.badge}
        </span>
        <span className="text-[#6D0EAF] text-3xl font-medium">
          {contract.badgePercent}
        </span>
      </div>
      {isGlobal && (
        <div className="flex flex-col items-center space-y-2">
          <span className="badge-gradient_2 text-white px-4 rounded-full text-xs font-bold">
            {contract.global_badge}
          </span>
          <ImgController
            src={assets.image.MetaColorIcon}
            alt="Mmusic Logo"
            className="h-4 w-19"
          />
        </div>
      )}
    </div>
  );
};

const ContractCard = ({ contract, isSelected, onSelect, onViewDetails }) => {
  return (
    <div className="relative">
      <div
        onClick={onSelect}
        className={`relative custom-BG px-4 py-5 flex flex-col space-y-4 max-w-[590px] z-50 border-2 transition-all cursor-pointer hover:border-mmusic ${
          isSelected ? "border-mmusic" : "border-white"
        }`}
      >
        <div className="flex justify-between items-center">
          <h5 className="font-bold text-xs italic">{contract.title}</h5>
          {isSelected ? (
            <div className="bg-mmusic text-white rounded-full w-5 h-5 flex items-center justify-center">
              <Check size={14} strokeWidth={4} />
            </div>
          ) : (
            <div className="border border-[#D0D5DD] w-5 h-5 rounded-full" />
          )}
        </div>
        <div className="flex items-center space-x-4">
          <p className="text-[#3b82f6] text-5xl font-bold">
            {contract.percentage}
          </p>
          <p className="text-[10px] leading-4">{contract.description}</p>
        </div>
        <div className="absolute bottom-1 right-4 flex items-center">
          <p
            className="text-[10px] text-mmusic font-normal"
            onClick={onViewDetails}
          >
            Гэрээний дэлгэрэнгүй үзэх
          </p>
          <IconController src={assets.svg.arrowRight} />
        </div>
      </div>

      <div className="absolute bottom-9 transform translate-y-1/3 -right-28">
        <ContractBadge contract={contract} />
      </div>
    </div>
  );
};

const ContractType = () => {
  const { data, setData, handleNext, handlePrevious } = useContract();
  const [showModal, setShowModal] = useState(false);
  const [popupConfig, setPopupConfig] = useState({
    visible: false,
    type: "",
    message: "",
  });
  const [selectedSection, setSelectedSection] = useState(null);

  const handleContractSelection = (contractType) => {
    setData((prev) => ({ ...prev, agreement_type: contractType }));
  };

  const handleViewDetails = (type) => {
    const section = getContractSection(type);
    setSelectedSection(section);
    setShowModal(true);
  };

  const handleTONext = () => {
    if (data.agreement_type === INTERNATIONAL_CONTRACT) {
      setPopupConfig({
        visible: true,
        type: "Info",
        message: "warningContract",
      });
    } else {
      handleNext();
    }
  };

  return (
    <>
      <div className="fixed top-5 right-5">
        <NotificationPopup
          popup={popupConfig.visible}
          setPopup={(val) =>
            setPopupConfig((prev) => ({ ...prev, visible: val }))
          }
          type={popupConfig.type}
          popupMessage={popupConfig.message}
          animDirectionTop
        />
      </div>
      <div
        className="h-full flex justify-start items-start bg-no-repeat bg-right-top bg-cover p-6 overflow-hidden"
        style={{
          backgroundImage: `url(${assets.image.cornerBG})`,
          backgroundSize: "57.5%",
        }}
      >
        <div className="h-full flex justify-center">
          <div className="flex flex-col space-y-3">
            {contracts.map((contract, index) => (
              <ContractCard
                key={index}
                contract={contract}
                isSelected={data.agreement_type === contract.agreement_type}
                onSelect={() =>
                  handleContractSelection(contract.agreement_type)
                }
                onViewDetails={() => handleViewDetails(contract.agreement_type)}
              />
            ))}
          </div>
        </div>
      </div>

      <ActionButtons
        handlePrevious={handlePrevious}
        onSubmit={handleTONext}
        isFormValid={!!data.agreement_type}
        previousLabel="Буцах"
        submitLabel="Үргэлжлүүлэх"
      />

      {showModal && selectedSection && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          section={selectedSection}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ContractType;
